import React from 'react'

const TextComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default TextComponent
